import React from "react";
import Lottie from "react-lottie-player";
import { useTranslation } from "react-i18next";

import { navLinks } from "@constants/navLinks";
import BaseScrollLink from "@components/toolkit/BaseScrollLink/BaseScrollLink";

import * as scrollIndicator from "@animations/scroll-indicator.json";

import "./Intro.scss";

const Intro = () => {
  const { t } = useTranslation("landing");

  return (
    <section id="intro" className="landing-intro">
      <picture>
        <video autoPlay muted loop playsInline className="intro__video-bg">
          <source src="/videos/intro-bg.webm" type="video/webm" />
          <source src="/videos/intro-bg.mp4" type="video/mp4" />
        </video>
      </picture>

      <div className="intro__main">
        <img
          src="/images/branding/finder-ai-logo.svg"
          alt={t("intro.logoAltTxt")}
          width={376}
          height={59}
          className="intro-logo"
        />
        <p className="h0 text-center intro-title">{t("intro.title")}</p>

        <div className="intro-hidden-block" />
      </div>

      <BaseScrollLink
        to={navLinks[0].sectionID}
        offset={navLinks[0].offsetTopDesktop}
        className="intro__scroll-indicator"
      >
        <Lottie play speed={1.2} loop animationData={scrollIndicator} />
      </BaseScrollLink>
    </section>
  );
};

export default Intro;
